
export type CancelEnrollmentBody = {
  /** 취소 사유 */
  reason?: string;
};
